import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowInstance} from "common/flowmaster/types/workflow";

export type WorkflowPrerequisiteFetchAction = {
  type: WorkflowsActionTypes["WORKFLOW_PREREQUISITE_FETCH"]["SUCCESS"];
  payload: WorkflowInstance[];
};

export default function getWorkflowPrerequisite(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_PREREQUISITE_FETCH,
    (organisationId: OrganisationId) => {
      return requestor
        .get(`${basePath}/organisation/${organisationId}/prerequisite`, {
          withCredentials: true,
        })
        .then(response => {
          return response.data;
        });
    },
  );
}
